// extracted by mini-css-extract-plugin
export default {"error":"Registration_error__qI4K-","container":"Registration_container__AaogK","box":"Registration_box__qYlLa","form":"Registration_form__MUp42"};